import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { formatShieldUrl } from '../../common/models/Rival';
export default class EditRivalPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "rival", null);
    _defineProperty(this, "isEdit", false);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "saving", false);
    // Form state
    _defineProperty(this, "name", '');
    _defineProperty(this, "selectedEscudo", null);
    _defineProperty(this, "division", '1ª');
    _defineProperty(this, "escudos", []);
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "divisionsBySeason", {});
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    const id = m.route.param('id');
    this.isEdit = !!id;

    // Load escudos and (optionally) the rival data
    this.loadData(id);
  }
  loadData(id) {
    this.loading = true;
    const promises = [
    // Load available shield images
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/escudos'
    }),
    // Load available seasons
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/seasons'
    })];
    if (this.isEdit && id) {
      promises.push(app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + "/nagusi/match-ratings/rivals/".concat(id)
      }));
    }
    Promise.all(promises).then(_ref => {
      let _ref2 = _slicedToArray(_ref, 3),
        escudosResponse = _ref2[0],
        seasonsResponse = _ref2[1],
        rivalResponse = _ref2[2];
      this.escudos = escudosResponse || [];
      this.seasons = app.store.pushPayload(seasonsResponse) || [];
      this.seasons.sort((a, b) => b.name().localeCompare(a.name()));
      if (this.isEdit && rivalResponse) {
        var _this$rival$attribute, _this$rival$attribute2, _this$rival$attribute3, _this$rival$attribute4;
        this.rival = rivalResponse.data;
        this.name = ((_this$rival$attribute = this.rival.attributes) == null ? void 0 : _this$rival$attribute.name) || '';
        this.selectedEscudo = ((_this$rival$attribute2 = this.rival.attributes) == null ? void 0 : _this$rival$attribute2.escudo) || null;
        this.division = ((_this$rival$attribute3 = this.rival.attributes) == null ? void 0 : _this$rival$attribute3.division) || '1ª';
        this.divisionsBySeason = ((_this$rival$attribute4 = this.rival.attributes) == null ? void 0 : _this$rival$attribute4.divisionsBySeason) || {};
      } else {
        this.divisionsBySeason = {};
      }
      this.loading = false;
      m.redraw();
    }).catch(e => {
      console.error('Error loading page data:', e);
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.rivals.edit_error_load'));
      m.route.set(app.route('bizkaitarra-lineup.rivals'));
    });
  }
  saveRival(e) {
    e.preventDefault();
    const nameClean = this.name.trim();
    if (!nameClean) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.rivals.error_name_empty'));
      return;
    }
    this.saving = true;
    const url = this.isEdit ? app.forum.attribute('apiUrl') + "/nagusi/match-ratings/rivals/".concat(this.rival.id) : app.forum.attribute('apiUrl') + '/nagusi/match-ratings/rivals';
    const method = this.isEdit ? 'PATCH' : 'POST';
    app.request({
      method: method,
      url: url,
      data: {
        data: {
          attributes: {
            name: nameClean,
            escudo: this.selectedEscudo,
            division: this.division,
            divisionsBySeason: this.divisionsBySeason
          }
        }
      }
    }).then(() => {
      this.saving = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans(this.isEdit ? 'bizkaitarra-lineup.forum.rivals.save_success' : 'bizkaitarra-lineup.forum.rivals.create_success'));
      m.route.set(app.route('bizkaitarra-lineup.rivals'));
    }).catch(error => {
      console.error('Error saving rival:', error);
      this.saving = false;
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('bizkaitarra-lineup.forum.rivals.save_error'));
      m.redraw();
    });
  }
  selectEscudo(filename) {
    this.selectedEscudo = filename;
    m.redraw();
  }
  view() {
    var _this$rival$attribute5;
    if (!this.canManage) return null;
    if (this.loading) {
      return m("div", {
        className: "EditRivalPage"
      }, m("div", {
        className: "container",
        style: "padding: 40px; text-align: center;"
      }, m(LoadingIndicator, null)));
    }
    const selectedUrl = formatShieldUrl(this.selectedEscudo);
    return m("div", {
      className: "EditRivalPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; gap: 15px; margin-bottom: 40px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.rivals'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-arrow-left"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.edit_back_rivals')), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina'),
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-user-shield"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.nav_back_taldezaina'))), m("div", {
      className: "EditRival-header",
      style: "margin-bottom: 40px; display: flex; align-items: center; gap: 20px;"
    }, selectedUrl ? m("img", {
      src: selectedUrl,
      alt: "Escudo",
      style: "height: 70px; width: 70px; object-fit: contain; border: 2px solid rgba(255, 255, 255, 0.1); padding: 4px; background: rgba(255,255,255,0.03); border-radius: 12px;"
    }) : m("div", {
      style: "height: 70px; width: 70px; border-radius: 12px; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; border: 2px solid rgba(255, 255, 255, 0.1);"
    }, m("i", {
      className: "fas fa-shield-alt",
      style: "font-size: 2.2rem; color: var(--muted-color);"
    })), m("div", null, m("h2", {
      style: "font-size: 2.2em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, app.translator.trans(this.isEdit ? 'bizkaitarra-lineup.forum.rivals.edit_title' : 'bizkaitarra-lineup.forum.rivals.create_title')), this.isEdit && m("p", {
      style: "color: var(--muted-color); font-size: 1.2em; margin-top: 4px;"
    }, (_this$rival$attribute5 = this.rival.attributes) == null ? void 0 : _this$rival$attribute5.name))), m("form", {
      onsubmit: this.saveRival.bind(this)
    }, m("div", {
      style: "max-width: 650px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); border-radius: 16px; padding: 30px; display: flex; flex-direction: column; gap: 20px; box-shadow: 0 8px 32px rgba(0,0,0,0.15);"
    }, m("h3", {
      style: "font-size: 1.3em; font-weight: bold; margin: 0 0 10px 0; border-bottom: 1px solid rgba(255,255,255,0.08); padding-bottom: 12px; color: var(--heading-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.section_details')), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.field_name'), " *"), m("input", {
      className: "FormControl",
      placeholder: String(app.translator.trans('bizkaitarra-lineup.forum.rivals.name_placeholder')),
      value: this.name,
      oninput: e => this.name = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px;",
      required: true
    })), m("div", {
      style: "display: flex; flex-direction: column; gap: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
    }, "Divisi\xF3n por Defecto (Fallback) *"), m("select", {
      className: "FormControl",
      value: this.division,
      onchange: e => this.division = e.target.value,
      style: "border-radius: 8px; border: 1px solid rgba(255,255,255,0.1); background: rgba(255,255,255,0.02); padding: 10px 14px; color: #fff; width: 100%; box-sizing: border-box;",
      required: true
    }, m("option", {
      value: "1\xAA"
    }, "1\xAA Divisi\xF3n (Primera)"), m("option", {
      value: "2\xAA"
    }, "2\xAA Divisi\xF3n (Segunda)"), m("option", {
      value: "1\xAA RFEF"
    }, "1\xAA RFEF (Primera Federaci\xF3n)"), m("option", {
      value: "2\xAA RFEF"
    }, "2\xAA RFEF (Segunda Federaci\xF3n)"), m("option", {
      value: "3\xAA RFEF"
    }, "3\xAA RFEF (Tercera Federaci\xF3n)"), m("option", {
      value: "Otra"
    }, "Otra / Copa / Europa"))), this.seasons.length > 0 && m("div", {
      style: "display: flex; flex-direction: column; gap: 12px; margin-top: 10px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 15px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--heading-color); font-size: 0.95em;"
    }, "Divisiones espec\xEDficas por Temporada"), m("p", {
      style: "color: var(--muted-color); font-size: 0.85em; margin: 0 0 5px 0;"
    }, "Establece una divisi\xF3n espec\xEDfica para cada temporada. Si se marca \"Por defecto\", utilizar\xE1 la divisi\xF3n por defecto configurada arriba."), m("div", {
      style: "display: flex; flex-direction: column; gap: 10px;"
    }, this.seasons.map(season => {
      const seasonId = String(season.id());
      const currentVal = this.divisionsBySeason[seasonId] || 'Ninguna';
      return m("div", {
        style: "display: flex; align-items: center; justify-content: space-between; background: rgba(255,255,255,0.02); padding: 10px 15px; border-radius: 8px; border: 1px solid rgba(255,255,255,0.05);"
      }, m("span", {
        style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em;"
      }, "Temporada ", season.name()), m("select", {
        className: "FormControl",
        value: currentVal,
        onchange: e => {
          this.divisionsBySeason[seasonId] = e.target.value;
          m.redraw();
        },
        style: "max-width: 200px; border-radius: 8px;"
      }, m("option", {
        value: "Ninguna"
      }, "Por defecto / No participa"), m("option", {
        value: "1\xAA"
      }, "1\xAA Divisi\xF3n"), m("option", {
        value: "2\xAA"
      }, "2\xAA Divisi\xF3n"), m("option", {
        value: "1\xAA RFEF"
      }, "1\xAA RFEF"), m("option", {
        value: "2\xAA RFEF"
      }, "2\xAA RFEF"), m("option", {
        value: "3\xAA RFEF"
      }, "3\xAA RFEF"), m("option", {
        value: "Otra"
      }, "Otra / Copa / Europa")));
    }))), m("div", {
      style: "display: flex; flex-direction: column; gap: 10px;"
    }, m("div", {
      style: "display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid rgba(255,255,255,0.04); padding-bottom: 8px;"
    }, m("label", {
      style: "font-weight: bold; color: var(--muted-color); font-size: 0.9em; margin: 0;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.section_shield')), m(Link, {
      href: app.route('bizkaitarra-lineup.rivals.escudos'),
      className: "Button Button--link Button--small",
      style: "font-weight: bold; text-decoration: none; display: inline-flex; align-items: center; gap: 4px; padding: 0;"
    }, m("i", {
      className: "fas fa-upload"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_upload_new'))), m("p", {
      style: "color: var(--muted-color); font-size: 0.85em; margin: 0 0 5px 0; line-height: 1.4;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.shields_selection_help')), m("div", {
      style: "display: grid; grid-template-columns: repeat(auto-fill, minmax(65px, 1fr)); gap: 10px; max-height: 180px; overflow-y: auto; padding: 5px; background: rgba(0,0,0,0.1); border-radius: 12px; border: 1px solid rgba(255,255,255,0.04);"
    }, m("div", {
      onclick: () => this.selectEscudo(null),
      style: "aspect-ratio: 1; border-radius: 10px; background: rgba(255,255,255,0.02); display: flex; flex-direction: column; align-items: center; justify-content: center; border: 2px solid ".concat(this.selectedEscudo === null ? 'var(--primary-color)' : 'rgba(255,255,255,0.08)', "; cursor: pointer; transition: all 0.2s ease;")
    }, m("i", {
      className: "fas fa-times-circle",
      style: "font-size: 1.5rem; color: var(--muted-color); opacity: 0.6;"
    }), m("span", {
      style: "font-size: 0.65em; margin-top: 3px; font-weight: bold; color: var(--muted-color);"
    }, "Ninguno")), this.escudos.map(escudo => {
      const isSelected = this.selectedEscudo === escudo.filename;
      return m("div", {
        key: escudo.filename,
        onclick: () => this.selectEscudo(escudo.filename),
        style: "aspect-ratio: 1; border-radius: 10px; background: rgba(255,255,255,0.04); display: flex; align-items: center; justify-content: center; border: 2px solid ".concat(isSelected ? 'var(--primary-color)' : 'rgba(255,255,255,0.08)', "; cursor: pointer; transition: all 0.2s ease; padding: 4px;"),
        title: escudo.filename
      }, m("img", {
        src: escudo.url,
        alt: escudo.filename,
        style: "max-height: 100%; max-width: 100%; object-fit: contain;"
      }));
    })), this.escudos.length === 0 && m("p", {
      style: "color: var(--muted-color); text-align: center; padding: 15px 0; font-style: italic; margin: 0; background: rgba(255,255,255,0.01); border-radius: 10px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.empty_shields'))), m("div", {
      style: "display: flex; flex-direction: column; align-items: center; gap: 10px; padding: 15px; background: rgba(255,255,255,0.01); border-radius: 12px; border: 1px dashed rgba(255,255,255,0.06); width: fit-content; align-self: center; min-width: 180px;"
    }, m("span", {
      style: "font-size: 0.85em; font-weight: bold; color: var(--muted-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.preview_label')), selectedUrl ? m("img", {
      src: selectedUrl,
      alt: "Preview",
      style: "height: 90px; width: 90px; object-fit: contain; filter: drop-shadow(0 4px 10px rgba(0,0,0,0.25));"
    }) : m("div", {
      style: "height: 90px; width: 90px; border-radius: 12px; background: rgba(255,255,255,0.03); display: flex; align-items: center; justify-content: center; border: 2px dashed rgba(255,255,255,0.08);"
    }, m("i", {
      className: "fas fa-shield-alt",
      style: "font-size: 3rem; color: var(--muted-color); opacity: 0.25;"
    }))), m("div", {
      style: "display: flex; justify-content: flex-end; gap: 15px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 20px; margin-top: 10px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.rivals'),
      className: "Button",
      style: "border-radius: 8px; padding: 10px 20px; font-weight: bold;"
    }, app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_cancel')), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.saving,
      style: "border-radius: 8px; padding: 10px 24px; font-weight: bold; display: inline-flex; align-items: center; gap: 8px;"
    }, m("i", {
      className: "fas fa-save"
    }), app.translator.trans('bizkaitarra-lineup.forum.rivals.btn_save')))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/EditRivalPage', EditRivalPage);